import { Component } from '@angular/core';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-loss-prevention-admin-investigation-queue',
  templateUrl: './investigation-queue.component.html',
  styleUrl: './investigation-queue.component.scss',
  standalone: false,
})
export class LossPreventionAdminInvestigationQueueComponent {
  public readonly lpManageQueuesUrl = `${environment.lpBaseUrl}/reviews/queue/manage`;
}
